import { cycloneApiClient } from '@/shared/api/core/axios-instance';

import type {
  AssetDetailParams,
  AssetDetailResponse,
  UpdateAssetDescriptionParams,
  UpdateAssetDescriptionRequest,
  UpdateAssetDescriptionResponse,
} from '@/entities/asset-search/domain/types';

export const fetchAssetDetail = async (params: AssetDetailParams): Promise<AssetDetailResponse> => {
  const { assetId, type, snapshotId, runId } = params;

  const queryParams: Record<string, string | number> = { type };

  if (snapshotId != null) {
    queryParams.snapshotId = snapshotId;
  }

  if (runId != null) {
    queryParams.runId = runId;
  }

  const response = await cycloneApiClient.get<AssetDetailResponse>(`/assets/${assetId}`, {
    params: queryParams,
  });

  return response.data;
};

export const updateAssetDescription = async (
  params: UpdateAssetDescriptionParams,
  data: UpdateAssetDescriptionRequest
): Promise<UpdateAssetDescriptionResponse> => {
  const { assetId, type, snapshotId, runId } = params;

  const queryParams: Record<string, string | number> = { type };

  if (snapshotId != null) {
    queryParams.snapshot_id = snapshotId;
  }

  if (runId != null) {
    queryParams.run_id = runId;
  }

  const response = await cycloneApiClient.patch<UpdateAssetDescriptionResponse>(`/assets/${assetId}`, data, {
    params: queryParams,
  });

  return response.data;
};
